import { render } from "./BuyForm.vue?vue&type=template&id=11982093&scoped=true"
import script from "./BuyForm.vue?vue&type=script&lang=js"
export * from "./BuyForm.vue?vue&type=script&lang=js"

import "./BuyForm.vue?vue&type=style&index=0&id=11982093&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11982093"]])

export default __exports__